<template>
  <div>
    <AppHeader @refreshPage="init" />
    <div class="container detail">
      <div class="page-header">
        <div class="icon-bar back" @click="handleBack"></div>
      </div>
      <div class="detail-info type2">
        <div
          class="img-box"
          v-if="info.image"
          :style="{
            backgroundImage: 'url(' + $store.state.imgUrl + info.image + ')'
          }"></div>
        <div class="share-w">
          <div class="share" @click="handleShare">
            <span>{{ $t('share') }}</span>
          </div>
        </div>
        <div class="pro-info">
          <div class="flexable">
            <div class="fan">
              x <span class="num"><span>3</span></span>
            </div>
            <div
              class="info"
              @click="
                () => {
                  ;(this.popType = 'info'), (this.popupVisible = true)
                }
              ">
              {{ $t('nftpage.text3') }}
            </div>
          </div>
        </div>
      </div>
      <div class="list3">
        <div class="title">{{ $t('nftpage.text4') }}</div>
        <div class="content">
          <div class="flexable">
            <div class="label">{{ $t('nftpage.text5') }}</div>
            <div
              class="val question"
              @click="
                () => {
                  ;(this.popType = 'more'), (this.popupVisible = true)
                }
              ">
              {{ $t('nftpage.text6') }}
            </div>
          </div>
          <!-- <div class="flexable">
            <div class="label discod">{{ $t('discord') }}</div>
            <a class="val">{{ $t('nftpage.text7') }}</a>
          </div> -->
        </div>
      </div>
      <div class="detail-des" v-if="info.babe_name">
        <div class="title">
          <div
            class="ava"
            :style="{
              backgroundImage:
                'url(' + $store.state.imgUrl + info.babe_avatar + ')'
            }"></div>
          {{ info.babe_name }}
        </div>
        <div class="des">
          {{ info.babe_profile }}
        </div>
      </div>
      <div class="footer">
        <div class="num">
          {{ info.sold }}<span class="unit">{{ $t('sold') }}</span>
        </div>
        <el-button
          type="primary"
          @click="handleShare"
          class="block el-button--special"
          style="color: #ffffff"
          >{{ $t('share') }}</el-button
        >
      </div>
      <div class="open-area" style="height: 1.1rem"></div>
    </div>
    <mt-popup
      v-model="popupVisible"
      position="bottom"
      :closeOnClickModal="false">
      <SharePop
        :sharePath="sharePath"
        @cancel="
          () => {
            this.popupVisible = false
          }
        "
        v-if="popType === 'share'" />
      <div class="pop-box type2" v-if="popType === 'info'">
        <div class="pop-title">{{ $t('nftpage.text3') }}</div>
        <div class="pop-list">
          <div class="flexable">
            <div class="label">{{ $t('nftpage.text9') }}</div>
            <div class="val">
              <el-tooltip
                class="item"
                effect="dark"
                :content="info.token_id"
                placement="top-start">
                <span>{{ parseText(info.token_id) }}</span>
              </el-tooltip>
            </div>
          </div>
          <div class="flexable">
            <div class="label">{{ $t('nftpage.text10') }}</div>
            <div class="val">
              <el-tooltip
                class="item"
                effect="dark"
                :content="info.nft_contract"
                placement="top-start">
                <span>{{ parseText(info.nft_contract) }}</span>
              </el-tooltip>
            </div>
          </div>
          <div class="flexable">
            <div class="label">{{ $t('nftpage.text11') }}</div>
            <div class="val">
              <el-tooltip
                class="item"
                effect="dark"
                :content="info.nft_blockchain"
                placement="top-start">
                <span>{{ parseText(info.nft_blockchain) }}</span>
              </el-tooltip>
            </div>
          </div>
          <div class="flexable">
            <div class="label">{{ $t('nftpage.text12') }}</div>
            <div class="val">
              <el-tooltip
                class="item"
                effect="dark"
                :content="info.nft_standard"
                placement="top-start">
                <span>{{ parseText(info.nft_standard) }}</span>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div class="pop-box type2" v-if="popType === 'more'">
        <div class="pop-title">{{ $t('nftpage.text13') }}</div>
        <div v-html="$t('add.text82')"></div>
      </div>
      <div
        class="pop-close"
        @click="
          () => {
            this.popupVisible = false
          }
        "></div>
    </mt-popup>
  </div>
</template>
<script>
import { postBabeNftInfo } from '@/api/babe'
import SharePop from '@/components/SharePop.vue'

export default {
  name: 'BabeHotNft',
  components: {
    SharePop
  },
  data() {
    return {
      popupVisible: false,
      selected: '1',
      info: {},
      popType: null
    }
  },
  watch: {
    popupVisible: {
      handler(n) {
        this.$stopScroll(n)
      },
      deep: true
    },
    '$i18n.locale'() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== this.$store.state.fromName) {
      this.$store.commit('SET_KEEP_ALIVE', [])
    }
    next()
  },
  methods: {
    parseText(text) {
      if (text.length > 21) {
        text = text.slice(0, 6) + '...' + text.substring(text.length - 4)
      }
      return text
    },
    init() {
      let params = {
        rec_code: this.$route.query.rec_code
      }
      postBabeNftInfo(params).then((res) => {
        this.info = res.data
      })
    },
    handleShare() {
      if (!this.$store.state.token) {
        this.$bus.emit('handleLogin')
      } else {
        this.sharePath =
          this.$store.state.userPath +
          '/user/nftdetail?inviteCode=' +
          this.$store.state.user_info.rec_code +
          '&inviteNft=' +
          this.info.rec_code +
          '&rec_code=' +
          this.info.rec_code
        console.log(this.sharePath)
        this.popType = 'share'
        this.popupVisible = true
      }
    },
    handleBack() {
      this.$router.back()
    }
  }
}
</script>
<style scoped lang="scss">
.mint-popup {
  .icon-block {
    .icon {
      margin: 0.1rem 0.25rem 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/babe/hotnft.vue